/* ==========================================================================
   GoFarWithSA Shopify theme — cart (AJAX Cart API), nav, search, toasts.
   ========================================================================== */

(function () {
  const fmt = (cents) => "₹" + (cents / 100).toLocaleString("en-IN", { maximumFractionDigits: 0 });

  const overlay = document.getElementById("overlay");
  const cartDrawer = document.getElementById("cartDrawer");
  const cartItemsEl = document.getElementById("cartItems");
  const cartFootEl = document.getElementById("cartFoot");
  const cartCountEl = document.getElementById("cartCount");
  const cartSubtotalEl = document.getElementById("cartSubtotal");
  const toastEl = document.getElementById("toast");
  const mainNav = document.getElementById("mainNav");
  const searchPanel = document.getElementById("searchPanel");

  /* ---------- Toast ---------- */
  let toastTimer;
  function showToast(msg) {
    if (!toastEl) return;
    toastEl.textContent = msg;
    toastEl.classList.add("show");
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => toastEl.classList.remove("show"), 2200);
  }

  /* ---------- Drawer open/close ---------- */
  function openCart() {
    cartDrawer.classList.add("open");
    overlay.classList.add("open");
  }
  function closeCart() {
    cartDrawer.classList.remove("open");
    overlay.classList.remove("open");
  }
  function closeMenu() { mainNav && mainNav.classList.remove("open"); }
  function closeSearch() { searchPanel && searchPanel.classList.remove("open"); }

  const cartToggle = document.getElementById("cartToggle");
  const cartClose = document.getElementById("cartClose");
  if (cartToggle) cartToggle.addEventListener("click", (e) => { e.preventDefault(); openCart(); });
  if (cartClose) cartClose.addEventListener("click", closeCart);
  if (overlay) overlay.addEventListener("click", () => { closeCart(); closeMenu(); closeSearch(); });

  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape") { closeCart(); closeMenu(); closeSearch(); }
  });

  /* ---------- Mobile nav ---------- */
  const menuToggle = document.getElementById("menuToggle");
  if (menuToggle) menuToggle.addEventListener("click", () => mainNav.classList.toggle("open"));

  /* ---------- Search toggle ---------- */
  const searchToggle = document.getElementById("searchToggle");
  if (searchToggle) searchToggle.addEventListener("click", () => {
    searchPanel.classList.toggle("open");
    if (searchPanel.classList.contains("open")) {
      searchPanel.querySelector("input[name='q']").focus();
    }
  });

  /* ---------- Cart rendering ---------- */
  function renderCart(cart) {
    cartCountEl.textContent = cart.item_count;

    if (cart.item_count === 0) {
      cartItemsEl.innerHTML = `<div class="cart-empty">Your bag is empty.<br>Add a Rida you love.</div>`;
      cartFootEl.style.display = "none";
      return;
    }
    cartFootEl.style.display = "block";

    cartItemsEl.innerHTML = cart.items.map((item) => `
      <div class="cart-item" data-key="${item.key}">
        <img src="${item.image}" alt="${item.title}">
        <div class="cart-item-info">
          <h4>${item.product_title}</h4>
          <div class="cat">${item.variant_title && item.variant_title !== "Default Title" ? item.variant_title : ""}</div>
          <div class="cart-item-row">
            <div class="qty-control">
              <button data-qty-minus="${item.key}">−</button>
              <span>${item.quantity}</span>
              <button data-qty-plus="${item.key}">+</button>
            </div>
            <strong>${fmt(item.final_line_price)}</strong>
          </div>
          <button class="remove-item" data-remove="${item.key}">Remove</button>
        </div>
      </div>
    `).join("");

    cartSubtotalEl.textContent = fmt(cart.total_price);
  }

  async function fetchCart() {
    const res = await fetch("/cart.js");
    return res.json();
  }

  async function addToCart(variantId, quantity = 1) {
    try {
      const res = await fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ id: variantId, quantity }),
      });
      if (!res.ok) {
        const err = await res.json();
        showToast(err.description || "Couldn't add that item — please try again.");
        return;
      }
      const cart = await fetchCart();
      renderCart(cart);
      showToast("Added to bag");
      openCart();
    } catch (err) {
      showToast("Something went wrong — please try again.");
    }
  }

  async function changeQuantity(key, quantity) {
    const res = await fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ id: key, quantity }),
    });
    const cart = await res.json();
    renderCart(cart);
  }

  /* ---------- Delegated cart item events ---------- */
  cartItemsEl.addEventListener("click", (e) => {
    const plus = e.target.closest("[data-qty-plus]");
    const minus = e.target.closest("[data-qty-minus]");
    const remove = e.target.closest("[data-remove]");
    if (plus) {
      const row = plus.closest(".cart-item");
      const qty = parseInt(row.querySelector(".qty-control span").textContent, 10) + 1;
      changeQuantity(plus.dataset.qtyPlus, qty);
    }
    if (minus) {
      const row = minus.closest(".cart-item");
      const qty = parseInt(row.querySelector(".qty-control span").textContent, 10) - 1;
      changeQuantity(minus.dataset.qtyMinus, Math.max(qty, 0));
    }
    if (remove) {
      changeQuantity(remove.dataset.remove, 0);
    }
  });

  /* ---------- Quick add buttons (product cards) ---------- */
  document.addEventListener("click", (e) => {
    const addBtn = e.target.closest("[data-add]");
    if (addBtn && !addBtn.closest("#PdpForm")) {
      e.preventDefault();
      addToCart(addBtn.dataset.add, 1);
    }
  });

  /* ---------- Product page add-to-cart form ---------- */
  const pdpForm = document.getElementById("PdpForm");
  if (pdpForm) {
    pdpForm.addEventListener("submit", (e) => {
      e.preventDefault();
      const variantId = document.getElementById("PdpVariantSelect").value;
      addToCart(variantId, 1);
    });
  }

  /* ---------- Product page option pills ---------- */
  document.querySelectorAll(".option-pill").forEach((pill) => {
    pill.addEventListener("click", () => {
      const group = pill.closest(".option-values");
      group.querySelectorAll(".option-pill").forEach((p) => p.classList.remove("selected"));
      pill.classList.add("selected");
      // For full variant-matrix matching, extend this to recompute the
      // selected variant from all option groups and update PdpVariantSelect + price.
    });
  });

  /* ---------- Init: sync cart count/subtotal on load ---------- */
  fetchCart().then(renderCart).catch(() => {});
})();
